import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=710a30d9&lang=pug"
import script from "./FooterBar.vue?vue&type=script&lang=ts"
export * from "./FooterBar.vue?vue&type=script&lang=ts"
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=710a30d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports